import React from 'react';
import EventOptionGroupsContainer from '../../../Containers/AdminContainer/EventOptionGroups';

const EventOptionGroupsScreen = () => {
  return <EventOptionGroupsContainer />;
};

export default EventOptionGroupsScreen;
